export default "__VITE_ASSET__bRE$x8g7__"